import {isDefined, isNullOrUndefined} from 'ceres/app/helper/utils';
import TranslationService from 'ceres/app/services/TranslationService';

const NotificationService = require('ceres/app/services/NotificationService');
const ApiService          = require('ceres/app/services/ApiService');


Vue.component('checkout-address-input-group', {


    delimiters: ['${', '}'],


    props: {
        defaultCountry: {
            type: String,
            default: 'DE'
        },
        addressType: String,
        template: String
    },


    data() {
        return {
            showAutocomplete: true,
            stateList: [],
            countryLocaleList: ['DE', 'GB'],
            localeToShow: this.defaultCountry,
            newGoogleAddress: false,
            stationAddress: '',
            stationAddressOld: '',
            stationList: [],
            isStationAddress: false,
            stationStreet: '',
            stationHouseNo: ''
        };
    },


    computed: {

        //todo: add is isPickupStation, isPostOffice and use instead of data variable 'stationList' for hiding current address edit (optimization)
        // isPickupStation() {
        //     return this.value && this.value.address1 === 'PACKSTATION' && this.isParcelBoxAvailable;
        // },
        //
        // isPostOffice() {
        //     return this.value && this.value.address1 === 'POSTFILIALE' && this.isPostOfficeAvailable;
        // },
        //
        // isParcelOrOfficeAvailable() {
        //     return (this.isParcelBoxAvailable || this.isPostOfficeAvailable) && this.selectedCountry && this.selectedCountry.isoCode2 === 'DE' && this.addressType === '2';
        // },

        ...Vuex.mapState({
            isParcelBoxAvailable:  state => state.checkout.shipping.isParcelBoxAvailable,
            isPostOfficeAvailable: state => state.checkout.shipping.isPostOfficeAvailable,
            countryList:           state => state.localization.shippingCountries,
            deliveryAddressId:     state => state.address.deliveryAddressId,
            addressToEdit:         state => state.address.addressToEdit
        })
    },


    created() {
        this.$options.template = this.template;
    },


    methods: {

        onSelectedCountryChanged(shippingCountry) {

            if(this.addressToEdit[this.addressType].countryId !== shippingCountry.id) {

                if (this.countryLocaleList.indexOf(shippingCountry.isoCode2) >= 0) {
                    this.localeToShow = shippingCountry.isoCode2;
                } else {
                    this.localeToShow = this.defaultCountry;
                }

                this.$store.commit('setEditedAddressField', {
                    field:       'countryId',
                    value:       shippingCountry.id,
                    addressType: this.addressType
                });

                // if (this.isPickupStation || this.isPostOffice) {
                //     this.togglePickupStation();
                // }
            }
        },

        toggleAutocomplete() {
            this.showAutocomplete = !this.showAutocomplete;
        },

        hideAutocomplete() {
            this.showAutocomplete = false;
        },

        setField(field, value) {
            this.$store.commit('setEditedAddressField', {
                field:       field,
                value:       value,
                addressType: this.addressType
            });
        },

        getAddressData(addressData) {

            let country = this.validateCountry(addressData.country.iso);

            if (country) {

                let tmpAddress = {};

                if(this.addressToEdit[this.addressType].countryId !==  country.id) {

                    this.newGoogleAddress = true;
                    tmpAddress.countryId  = country.id;

                }

                tmpAddress.address1   = addressData.address1;
                tmpAddress.address2   = addressData.address2;
                tmpAddress.address3   = '';
                tmpAddress.town       = addressData.town;
                tmpAddress.postalCode = addressData.postalCode;

                if(
                    typeof tmpAddress.address1 === 'undefined' ||
                    typeof tmpAddress.address2 === 'undefined' ||
                    typeof tmpAddress.address3 === 'undefined' ||
                    typeof tmpAddress.town === 'undefined' ||
                    typeof tmpAddress.postalCode === 'undefined'
                ) {
                    this.showAutocomplete = false;
                }

                this.isStationAddress = false;

                this.$store.commit('setEditedAddress', {
                    address:     tmpAddress,
                    addressType: this.addressType
                });

            }else{
                NotificationService.error(
                    TranslationService.translate('ODFashioncode::Fashioncode.checkoutCountryNA')
                )
            }

        },

        getTownData(addressData) {

            let country = this.validateCountry(addressData.city.country.iso);

            if (country) {

                this.stationAddress = addressData.string;

            }else{
                NotificationService.error(
                    TranslationService.translate('ODFashioncode::Fashioncode.checkoutCountryNA')
                )
            }
        },

        searchStation() {

            if(this.stationAddressOld !== this.stationAddress) {

                ApiService
                    .get('/rest/fashioncode/packingstation', {city: this.stationAddress})
                    .done(function(response) {

                        if (isDefined(response.psfParcellocationList)) {

                            this.stationList       = response.psfParcellocationList;
                            this.stationAddressOld = this.stationAddress;

                            $('#id--packing-station-modal').modal('show');

                        }else{
                            NotificationService.error(
                                TranslationService.translate('error')
                            )
                        }

                    }.bind(this));

            }else{
                $('#id--packing-station-modal').modal('show');
            }
        },

        setStationAddress(address) {

            let country = this.validateCountry(address.countryCode.toUpperCase());

            if(country) {

                let tmpAddress = {};

                if(this.addressToEdit[this.addressType].countryId !==  country.id) {

                    this.newGoogleAddress = true;
                    tmpAddress.countryId  = country.id;
                }

                /**
                 * @link https://parcelshopfinder.dhlparcel.com/html/note_direct_access_germany.html?setLng=de
                 */
                if(address.shopType.toLowerCase().indexOf('packstation') > -1) {
                    tmpAddress.address1 = TranslationService.translate('ODFashioncode::Fashioncode.checkoutPackingstation')
                }else if(address.shopType.toLowerCase().indexOf('postoffice') > -1) {
                    tmpAddress.address1 = TranslationService.translate('ODFashioncode::Fashioncode.checkoutPostoffice')
                }else{
                    tmpAddress.address1 = address.keyWord;
                }

                tmpAddress.address2   = address.primaryKeyZipRegion;
                tmpAddress.address3   = '';
                tmpAddress.town       = address.city;
                tmpAddress.postalCode = address.zipCode;

                //not used
                this.stationStreet    = address.street;
                this.stationHouseNo   = address.houseNo;

                this.isStationAddress = true;

                this.$store.commit('setEditedAddress', {
                    address:     tmpAddress,
                    addressType: this.addressType
                });

                $('#id--packing-station-modal').modal('hide');

            }else{
                NotificationService.error(
                    TranslationService.translate('ODFashioncode::Fashioncode.checkoutCountryNA')
                )
            }

        },

        validateCountry(iso) {

            for (let key in this.countryList) {
                if (this.countryList.hasOwnProperty(key)) {

                    let value =  this.countryList[key];

                    if(value.isoCode2 === iso) {
                        return value;
                    }
                }
            }

            return false;

        },

        handleError(error) {
            alert(error)
        },

        getCountryName(countryId) {

            if (countryId > 0) {

                const country = this.countryList.find(country => country.id === countryId);

                if (!isNullOrUndefined(country)) {
                    return country.currLangName;
                }
            }

            return '';
        },

        formatDistance(meter) {

            if(meter.toString().length > 3) {
                return (meter / 1000).toFixed(1) + 'km';
            }else{
                return meter + 'm';
            }

        },

        //not used
        togglePickupStation() {

            //check if country change comes through google autocomplete
            //if so skip this function, so google address fields would not be overridden
            if(!this.newGoogleAddress) {

                this.newGoogleAddress = false;

                this.$store.commit('setEditedAddress', {
                    address: {
                        address1: '',
                        address2: '',
                        address3: '',
                        postalCode: '',
                        town: ''
                    },
                    addressType: this.addressType
                });


            }else{
                this.newGoogleAddress = false;
            }
        },

        //not used
        toggleAutocompleteStation() {
            console.log('toggleAutocompleteStation');
        }
    },


    filters: {
        optionType(selectedAddress, typeId) {

            if (selectedAddress && selectedAddress.name2) {
                for (const optionType of selectedAddress.options) {
                    if (optionType.typeId === typeId) {
                        return optionType.value;
                    }
                }
            }

            return '';
        }
    }
});
